import React from 'react';
import { Form } from 'react-bootstrap';
import ColorSwatch from "./ColorSwatch";

export const renderShadowControls = ({ shape, updateObject }) => {
  if (!shape) return null;

  const expandHex = (hex) => {
    if (hex.length === 4) {
      return '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }
    return hex;
  };


  return (
    <>
      <br/><Form.Group className="mb-2">
        <ColorSwatch
          label="Shadow Color:"
          value={expandHex(shape.shadowColor ?? '#000000')}
          onChange={(color) =>
            updateObject(shape.id, { shadowColor: color })
          }
          allowTransparent
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label>Blur:&nbsp;</Form.Label>
        <Form.Range
          min={0}
          max={50}
          value={shape.shadowBlur ?? 0}
          onChange={(e) =>
            updateObject(shape.id, { shadowBlur: parseFloat(e.target.value) })
          }
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label>Offset X:&nbsp;</Form.Label>
        <Form.Control
          type="number"
          style={{ width: '50px' }}  // 👈 Adjust as needed
          value={shape.shadowOffsetX ?? 0}
          onChange={(e) =>
            updateObject(shape.id, { shadowOffsetX: parseFloat(e.target.value) })
          }
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label>Offset Y:&nbsp;</Form.Label>
        <Form.Control
          type="number"
          value={shape.shadowOffsetY ?? 0}
          style={{ width: '50px' }}  // 👈 Adjust as needed
          onChange={(e) =>
            updateObject(shape.id, { shadowOffsetY: parseFloat(e.target.value) })
          }
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label>Shadow Opacity:&nbsp;</Form.Label>
        <Form.Range
          min={0}
          max={1}
          step={0.01}
          value={shape.shadowOpacity ?? 1}
          onChange={(e) =>
            updateObject(shape.id, { shadowOpacity: parseFloat(e.target.value) })
          }
        />
      </Form.Group>
    </>
  );
};
